import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PerfilSeccionEstado } from '../../../data/perfil-microempresario.content';

@Component({
  selector: 'app-perfil-progress-section',
  templateUrl: './perfil-progress-section.component.html',
  styleUrls: ['./perfil-progress-section.component.scss'],
  standalone: false,
})
export class PerfilProgressSectionComponent {
  @Input() progreso = 0;
  @Input() checkpoints = 2;
  @Input() estado: PerfilSeccionEstado = 'pendiente';
  /** Resalta el primer checkpoint (anillo teal) cuando la sección está activa y el avance es 0. */
  @Input() highlightCurrent = false;
  @Input() clickable = false;
  @Output() markerClick = new EventEmitter<number>();

  get progresoClamped(): number {
    return Math.max(0, Math.min(100, this.progreso ?? 0));
  }

  /** Relleno mínimo visual en sección activa a 0% (Figma). */
  get fillWidth(): number {
    if (this.highlightCurrent && this.progresoClamped <= 0) {
      return 8;
    }
    return this.progresoClamped;
  }

  get markers(): number[] {
    const count = Math.max(2, this.checkpoints || 2);
    return Array.from({ length: count }, (_, i) => i);
  }

  isMarkerDone(index: number): boolean {
    // A 0% ningún checkpoint está activo (Figma: todos grises al inicio).
    if (this.progresoClamped <= 0) {
      return false;
    }
    const count = this.markers.length;
    if (count <= 1) {
      return this.progresoClamped >= 100;
    }
    const threshold = (index / (count - 1)) * 100;
    return this.progresoClamped >= threshold;
  }

  isMarkerCurrent(index: number): boolean {
    return this.highlightCurrent && this.progresoClamped <= 0 && index === 0;
  }

  onMarkerClick(event: Event, index: number): void {
    if (!this.clickable) {
      return;
    }
    event.preventDefault();
    event.stopPropagation();
    this.markerClick.emit(index);
  }
}
